<h1 mat-dialog-title>Preferences</h1>
<div mat-dialog-content>
  <p>General settings</p>
  <mat-form-field appearance="fill" *ngIf="apiRootFormControl">
    <mat-label>Api root URL</mat-label>
    <input matInput type="text" [formControl]="apiRootFormControl" />
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button [disabled]="!apiRootFormControl" cdkFocusInitial [mat-dialog-close]="this.apiRootFormControl?.value">Ok</button>
</div>
